
import CustomInput from '@/components/common/CustomInput';
import Images from '@/components/common/Images';
import { PhoneOtpInput } from '@/components/common/PhoneOtpInput';
import { ProfileAvatar } from '@/components/common/ProfileAvatar';
import ProfileAndAvatarModal from '@/components/Modals/ProfileAndAvatarModal';
import { Button } from '@/components/ui/button';
import useProfileHook from '@/hooks/useProfileHook';
import { ProfileLayout } from '@/layouts/ProfileLayout';
import { RootState } from '@/store';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
  const navigate = useNavigate();

  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const {
    control,
    isEditing,
    setEditng,
    updateUserLoading,
    onSubmit,
    phone,
    setPhone,
    showOtpField,
    setShowOtpField,
    timeLeft,
    handleSendOtp,
    handleResetOtpField,
    resetField,
    active,
    handleSubmit,
  } = useProfileHook();

  const user = useSelector((s: RootState) => s.user.profile);
  return (
    <ProfileLayout>
      <div className="flex flex-col items-center  pb-6">
        {/* ── Profile hero ── */}
        <h1 className="text-white text-lg font-semibold mb-4">Profile</h1>

        {/* Avatar */}

        <button
          className="relative cursor-pointer mb-10"
          onClick={() => setIsProfileModalOpen(true)}
        >
          <ProfileAvatar
            size="md"
            image={user?.profileImage || ''}
            username={user?.username}
            isVerified={user?.isVerified}
            isCamera={true}
            fallbackSrc="/matches/nodata/fallbackprofile.webp"
          />
        </button>

        {/* ── Form card ── */}
        <div className="gradient-box bg-transparent w-full p-4 rounded-2xl">
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <div className="flex justify-end gap-2">
              {isEditing && (
                <Button
                  type="button"
                  variant="destructive"
                  onClick={() => {
                    setEditng(false);
                    setShowOtpField(false);
                    resetField('otp');
                  }}
                >
                  Cancel
                </Button>
              )}

              {!isEditing ? (
                <button
                  type="button"
                  className="bg-btn-gradient2 text-primary-foreground hover:bg-btn-gradient/90 h-10 px-4 py-2 rounded-md  text-sm font-medium"
                  onClick={() => setEditng(true)}
                >
                  Edit Profile
                </button>
              ) : (
                <Button type="submit" disabled={updateUserLoading}>
                  {updateUserLoading ? 'Saving...' : 'Save Changes'}
                </Button>
              )}
            </div>
            <CustomInput
              name="username"
              control={control}
              label="User Name"
              readOnly={!isEditing}
            />

            <PhoneOtpInput
              control={control}
              phone={phone}
              setPhone={setPhone}
              showOtpButton={isEditing}
              active={active}
              showOtpField={showOtpField}
              timeLeft={timeLeft}
              handleSendOtp={handleSendOtp}
              handleResetOtpField={handleResetOtpField}
            />
          </form>

          <CustomInput name="credits" control={control} label="Credits" readOnly />

          <CustomInput name="referralCount" control={control} label="Referral Count" readOnly />
        </div>
        <div
          className="w-full flex justify-between text-white rounded-lg mt-5 text-base border items-center border-primary-border px-2 py-1"
          onClick={() => {
            navigate('/change-password');
          }}
        >
          <span className="underline">Change Password</span>{' '}
          <div className="rounded-full p-2 bg-primary-tabg">
            <Images src="/auth/change.svg" alt="change" />
          </div>
        </div>
      </div>
      {isProfileModalOpen && (
        <ProfileAndAvatarModal
          isProfileModalOpen={isProfileModalOpen}
          onClose={() => setIsProfileModalOpen(false)}
          className="max-w-md max-h-[85vh]"
        />
      )}
    </ProfileLayout>
  );
};

export default Profile;
